import React from 'react';
import '../toolbar/BoardRefreshContextMenu.css';

/**
 * Item de menu que abre o modal "Filtrar SLA" (sem checkbox).
 */
export function BoardFiltrarSLATrigger({ filterActive, onOpen, disabled }) {
  return (
    <div className="refresh-context-menu-checkbox-wrap">
      <button
        type="button"
        disabled={!!disabled}
        onClick={onOpen}
        className={[
          'refresh-context-menu-sla-btn',
          filterActive ? 'is-active' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        aria-label="Filtrar SLA"
      >
        <i className="bi bi-funnel" aria-hidden />
        <span>Filtrar SLA</span>
        {filterActive ? (
          <span className="refresh-context-menu-sla-badge">ativo</span>
        ) : null}
      </button>
    </div>
  );
}
